import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getKakaoStatus, startKakaoLogin } from "../services/kakao";
import "./KakaoLoginButton.css";

/**
 * Kakao's brand guidelines require the yellow (#FEE500) button and the speech
 * bubble mark. Renders nothing at all until the backend says Kakao is
 * configured, so it stays invisible until the keys are in place.
 */
const KakaoLoginButton = ({ next = "/", referralCode = null }) => {
  const { t } = useTranslation();
  const [enabled, setEnabled] = useState(false);
  const [going, setGoing] = useState(false);

  useEffect(() => {
    let alive = true;
    getKakaoStatus().then((cfg) => {
      if (alive) setEnabled(Boolean(cfg.enabled));
    });
    return () => { alive = false; };
  }, []);

  if (!enabled) return null;

  const go = async () => {
    setGoing(true);
    const started = await startKakaoLogin({ next, referralCode });
    if (!started) setGoing(false);
  };

  return (
    <>
      <div className="kakao-divider">
        <span>{t("auth.or")}</span>
      </div>
      <button type="button" className="kakao-btn" onClick={go} disabled={going}>
        <svg viewBox="0 0 24 24" width="19" height="19" aria-hidden="true">
          <path
            fill="#000000"
            d="M12 3C6.99 3 3 6.24 3 10.24c0 2.52 1.65 4.73 4.14 6.02l-1.05 3.86c-.09.34.29.61.59.42l4.6-3.04c.23.02.47.03.72.03 5.01 0 9-3.24 9-7.29S17.01 3 12 3z"
          />
        </svg>
        {t("auth.kakaoLogin")}
      </button>
    </>
  );
};

export default KakaoLoginButton;
